import { render } from "./MainTop.vue?vue&type=template&id=09779722&scoped=true"
import script from "./MainTop.vue?vue&type=script&lang=js"
export * from "./MainTop.vue?vue&type=script&lang=js"

import "./MainTop.vue?vue&type=style&index=0&id=09779722&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09779722"]])

export default __exports__